import { defineStore } from 'pinia';
import { store } from '@/store';

export interface ICachedViewsState {
  cachedViews: string[];
}

export const useCachedViewsStore = defineStore({
  id: 'app-cached-views',
  state: (): ICachedViewsState => ({
    cachedViews: ['Home', 'Area', 'Search'],
  }),
  getters: {
    getCachedViews(): string[] {
      return this.cachedViews;
    },
  },
  actions: {
    // 添加缓存视图
    addCachedView(viewName: string) {
      if (!this.cachedViews.includes(viewName)) {
        this.cachedViews.push(viewName);
      }
    },
    // 移除缓存视图
    removeCachedView(viewName: string) {
      const index = this.cachedViews.indexOf(viewName);
      if (index > -1) {
        this.cachedViews.splice(index, 1);
      }
    },
    // 设置缓存视图列表
    setCachedViews(views: string[]) {
      this.cachedViews = views;
    },
  },
});

// Need to be used outside the setup
export function useCachedViews() {
  return useCachedViewsStore(store);
}

